<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
	<div *ngFor="let line of contentLine$ | async">
		{{ line }} &nbsp;
		<!-- Always add a &nbsp; in case a line is intentionally empty, to act as vertical space -->
	</div>
</div>
<ng-content></ng-content>
<div mat-dialog-actions class="action-buttons">
	<button mat-button [color]="data.noButtonColor" *ngIf="data.noButtonText" (click)="onNo()">
		{{ data.noButtonText | uppercase }}
	</button>
	<button mat-raised-button cdkFocusInitial [color]="data.yesButtonColor" (click)="onYes()">
		{{ data.yesButtonText | uppercase }}
	</button>
</div>
